import { render } from "./ConfirmCode.vue?vue&type=template&id=0c5edcd3"
import script from "./ConfirmCode.vue?vue&type=script&lang=js"
export * from "./ConfirmCode.vue?vue&type=script&lang=js"

import "./ConfirmCode.vue?vue&type=style&index=0&id=0c5edcd3&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__